import { CurrencyEnum } from './currency-enum';

export class Constants {
  static techStopLabel = 'Fuel Stop';

  static EMAILS_EVENT_TYPE_ENUM_CLICK = 'The recipient clicked one or more links in the email.';
  static EMAILS_EVENT_TYPE_ENUM_BOUNCE =
    'When you receive bounces marked Permanent, you should remove the corresponding email addresses from your mailing list; you will not be able to send to them in the future. Transient bounces are sent to you when a message has soft bounced several times, and Amazon SES has stopped trying to re-deliver it. You may be able to successfully resend to an address that initially resulted in a Transient bounce in the future.';
  static EMAILS_EVENT_TYPE_ENUM_COMPLAINT =
    'The email was successfully delivered to the recipient`s mail server, but the recipient marked it as spam.';
  static EMAILS_EVENT_TYPE_ENUM_SEND =
    'The send request was successful and Amazon SES will attempt to deliver the message to the recipient`s mail server. (If account-level or global suppression is being used, SES will still count it as a send, but delivery is suppressed)';
  static EMAILS_EVENT_TYPE_ENUM_DELIVERY =
    'Amazon SES successfully delivered the email to the recipient`s mail server.';
  static EMAILS_EVENT_TYPE_ENUM_OPEN =
    'The recipient received the message and opened it in their email client.';
  static EMAILS_EVENT_TYPE_ENUM_REJECT =
    'Amazon SES accepted the email, but determined that it contained a virus and didn`t attempt to deliver it to the recipient`s mail server.';
}

export const currencyList = [
  {
    currency: CurrencyEnum.USD,
    country: 'us',
  },
  {
    currency: CurrencyEnum.EUR,
    country: 'eu',
  },
  {
    currency: CurrencyEnum.GBP,
    country: 'gb',
  },
];
